import { useEffect, useState } from 'react';
import { SelectArrayInput } from 'react-admin';

import { filtersDataProvider } from '@/dataProvider';
import { ICompaniesFilter, ICompaniesSelect } from '@/types';

function TransactionsCompaniesAutocompleteInput(): JSX.Element {
  const [companiesFilter, setCompaniesFilter] = useState<ICompaniesSelect[]>([]);

  const getCompaniesFilter = async (): Promise<ICompaniesFilter[]> => {
    const companies = await filtersDataProvider.getCompanies();
    const selectData = companies.map(item => ({ ...item, name: item.company_name }));
    setCompaniesFilter(selectData);

    return companies;
  };

  useEffect(() => {
    void getCompaniesFilter();
  }, []);

  return (
    <>
      <SelectArrayInput
        label="resources.transactions.companies"
        source="companies"
        optionValue="id"
        choices={companiesFilter}
        sx={{
          width: 300,
          ['& .RaSelectArrayInput-chips']: {
            overflow: 'hidden',
            display: 'flex',
            flexWrap: 'nowrap',
            width: 250,
          },
        }}
        options={{
          renderValue: (selected: any) =>
            selected
              .map((item: any) => companiesFilter.find(company => company.id === item)?.name)
              .filter((item: any) => !!item)
              .join(', '),
        }}
      />
    </>
  );
}

export default TransactionsCompaniesAutocompleteInput;
